module.exports = __webpack_public_path__ + "img/80017.46a200a0.png";